export const shortWeekdayLabels = {
    weekdayShort: ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
};

export const monthNames = [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек",
];
